<template>
    <div class="flex flex-col">
        <Scroll class="h-full pr-2">
            <div>
                <Item class="mt-2" v-for="item in cartItems" :key="item.timestamp">
                    <div class="overflow-auto lg:overflow-hidden w-full inline-flex lg:flex justify-between items-center" slot="body">
                        <CustomSelectCheckout icon="ShoppingCartIcon" class="w-1/2 h-8 lg:h-full flex-none mr-2" v-model="item.systemId" @input="clearItem(item)" :disabled="status == 'proccessed'">
                            <option slot="item" :text="system.name" :value="system.systemId" v-for="(system, indexSystem) in items" :key="indexSystem">{{system.name}}</option>
                        </CustomSelectCheckout>
                        <CustomSelectCheckout icon="ShoppingCartIcon" class="w-1/2 mr-2 h-8 lg:h-full flex-none" v-model="item.packageId" :disabled="status !== 'created' || (item.systemId == null)" @input="(packageId) => setItemPackage(item)">
                            <option slot="item" :text="itemPackage.name" :value="itemPackage.packageId" v-for="(itemPackage, indexPackage) in (item.systemId ? (items.find(system => system.systemId === item.systemId)).packages : [])" :key="indexPackage">{{itemPackage.name}}</option>
                        </CustomSelectCheckout>
                    </div>
                    <SubTotalItem :price="item.price" :priceGiven="item.priceGiven" :error="item.error" slot="subtotal" class="w-full" v-model="item.priceGiven" @input="checkPrice(item)" :disabled="status === 'proccessed'"></SubTotalItem>
                    <feather-icon class="cursor-pointer" icon="XIcon" slot="remove" @click="removeItem(item.timestamp)" v-show="status === 'created'"></feather-icon>
                    <div slot="bottom" class="pt-1 text-primary" v-if="item.hasRecurring">
                        <div>Mensal</div>
                    </div>
                </Item>
            </div>
        </Scroll>
        <vs-button class="block lg:hidden" @click="() => addItem({})" :disabled="status == 'proccessed'">Novo Item</vs-button>
    </div>
</template>

<script>
export default {
    components: {
        Scroll: () => import("vue-perfect-scrollbar"),
        Item: () => import("./Components/Item"),
        SelectCheckout: () => import("./Components/SelectCheckout"),
        SubTotalItem: () => import("./Components/SubTotalItem"),
        CustomSelectCheckout: () => import("./Components/CustomSelectCheckout"),

    },

    props: {
        active: Boolean,
        items: {
            type: Array,
            required: true
        },
        status: {
            required: true,
            type: String,
            validator: (val) => ["created", "processed"]
        }
    },

    data () {
        return {
            cartItems: []
        }
    },

    methods: {
        setItemPackage (item) {
            const packageData = (this.items.filter(system => system.systemId === item.systemId)[0]).packages.filter(packageItem => packageItem.packageId === item.packageId)[0];
            item.price = packageData.price;
            item.priceGiven = packageData.price;
            item.name = packageData.name;
            item.maxDiscount = packageData.maxDiscount;
            item.hasRecurring = packageData.hasRecurring;
            item.receivedInHands = false;
            item.quantity_of_parcels = 1;
        },
        clearItem (item) {
            item.packageId = null;
        },
        checkPrice (item) {
            if ((Number(item.price) - Number(item.priceGiven)) > (Number(item.price) * (Number(item.maxDiscount)) / 100) || Number(item.price) < Number(item.priceGiven)) {
                item.error = true;
                return;
            } else {
                item.error = false;
            }
        },
        addItem (item) {
            item.timestamp = new Date().getTime();
            if(!item) {
                item = {
                    name: '',
                    price: 0.00,
                    priceGiven: 0.00,
                    discount: '',
                    maxDiscount: 0.00,
                    receiveInHands: false,
                    error: false,
                    systemId: 0,
                    packageId: 0,
                    hasRecurring:false,
                    period: {
                        text: 'Cobrança mensal',
                        value: 1,
                        index: 0
                    }
                }
            }

            this.cartItems.push(item);
        },

        removeItem (timestamp) {
            const itemIndex = this.cartItems.findIndex(item => item.timestamp === timestamp);
            this.cartItems.splice(itemIndex, 1);
        }
    },

    watch: {
        cartItems: {
            handler (newValue) {
                this.$emit('change', newValue);
            },
             deep: true
        }
    }
}
</script>

<style>

</style>
